import { AuditMode } from "@/interfaces/Audit";

export const COMPLIANCE_LEVEL = {
  CUMPLE: 1,
  NO_CUMPLE: 2,
  CUMPLE_PARCIALMENTE: 3,
  NO_APLICA: 4,
};

export const COMPLIANCE_LEVEL_CONFIG = {
  1: {
    label: "C",
  },
  2: {
    label: "NC",
  },
  3: {
    label: "CP",
  },
  4: {
    label: "NA",
  },
};

// ==========================================
// Configuracion de modo de auditoria
// ==========================================

export const AUDIT_MODES_CONFIG = {
  flex: {
    label: "Diagnóstico",
    color: "blue",
    hexColor: "#2768F5",
    badge: "Diagnóstico",
    buttonText: "Comenzar Diagnóstico",
  },
  rigorous: {
    label: "Auditoría",
    color: "orange",
    hexColor: "#C71B00",
    badge: "Auditoría",
    buttonText: "Comenzar Auditoría",
  },
} as const;

/**
 * Configuracion de UI para el componente select
 * de Ant Design al momento que se va a iniciar
 * o crear una nueva auditoria.
 * Formato de respuesta especial Array[{ label: string, value: string }]
 * para ser implementado directamente por el Ant Design component
 */
export const AUDIT_MODES_SELECT_OPTIONS = Object.entries(
  AUDIT_MODES_CONFIG,
).map(([value, config]) => ({ label: config.label, value }));

/**
 * Array de los valores validos de audit_mode
 * para ser usado por Yup .oneOf() y las validaciones
 */
export const AUDIT_MODE_VALUES = Object.keys(AUDIT_MODES_CONFIG) as AuditMode[];

/**
 * Obtener el label de un modo de auditoria
 * @param mode string => key of AUDIT_MODES_CONFIG
 * @returns string => label the AUDIT_MODES_CONFIG
 */
export function getAuditModeLabel(mode: string | undefined): string {
  if (mode && mode in AUDIT_MODES_CONFIG) {
    return AUDIT_MODES_CONFIG[mode as AuditMode].label;
  }
  return mode ?? "";
}

/**
 * Recuperar la configuracion completa de un modo de auditoria
 * @param mode string => AuditMode "flex" | "rigorous"
 * @returns Object => AUDIT_MODES_CONFIG.flex | AUDIT_MODES_CONFIG.rigorous
 */
export function getAuditModeConfig(
  mode: AuditMode,
): (typeof AUDIT_MODES_CONFIG)[AuditMode] {
  return AUDIT_MODES_CONFIG[mode];
}

/**
 * Obtener el texto del boton para un modo de auditoria
 * Si el AUDIT_MODES_CONFIG no tiene el texto de boton
 * para el modo en param se retorna el string "Comenzar"
 * @param mode string => AuditMode "flex" | "rigorous"
 * @returns string => AUDIT_MODES_CONFIG.(mode).buttonText
 */
export function getAuditModeButtonText(mode: string | undefined): string {
  if (mode && mode in AUDIT_MODES_CONFIG) {
    return AUDIT_MODES_CONFIG[mode as AuditMode].buttonText;
  }
  return "Comenzar";
}

export function isValidAuditMode(value: string): value is AuditMode {
  return AUDIT_MODE_VALUES.includes(value as AuditMode);
}
